module.exports = __webpack_public_path__ + "img/funplus.b31a461a.png";